<template>
  <div class="container">
    <div class="row mt-4">
      <div class="col">
        <h3>About Us</h3>
      </div>
    </div>
    <div class="row pb-4 text-left">
      <div class="col ml-4">
        <h5><strong>Mission Statement</strong></h5>
        <p>
          We improve education by providing teachers simple and personalized
          funding opportunities, writing resources, and time management tools
          for grants to improve student learning experiences.
        </p>
        <h5><strong>Background</strong></h5>
        <p>
          Funds Granted was founded by passionate individuals with years of
          experience in education, grant writing, business development, and
          computer science.
        </p>
        <p>
          Educators throughout the United States impact students on a day-to-day
          basis. Teachers bear an enormous amount of responsibility when they
          agree to contribute to the overall success, growth, education, and
          well-being of their students. The responsibilities are
          multidimensional and complex. Strong pedagogical practices are the
          focus for effective teachers in all grade levels and for all
          disciplines, however, teachers nationwide are struggling because they
          do not have sufficient funding and support. Federal funding is
          available, but the disconnect is oftentimes, teachers are unaware of
          such opportunities and/or are unfamiliar with the funding request
          process. Funds Granted focuses on bridging this gap and providing
          educators with the resources necessary to continue their teaching
          practices and to work towards the best student outcomes.
        </p>
        <p>
          School funding allocations vary significantly by state and within
          school districts and do not always cover essential classroom needs. To
          supplement these funding gaps, 94% of educators are contributing
          needed supplies, resulting in an average of $500 per educator.
          Additionally, educators work on average 9-15 unpaid hours each week,
          demonstrating a lack of time to apply for time consuming grants.
        </p>
        <p>
          Funds Granted is a new software that revolutionizes the grant writing,
          application, and management process for educators. The software
          provides personalized funding opportunities, a variety of response
          templates, offers grant management features, tutorials and blogs, and
          training to ensure quality applications. Intended users include
          teachers, administrators, and educational specialists. Increased grant
          applications from educators will increase classroom funding and
          contribute to student learning opportunities.
        </p>
        <p>
          With the ever-increasing demand for funding in public education, Funds
          Granted seeks to supplement the funding gaps through increasing
          quality grant submissions from educators. Increased grant submissions
          will contribute to additional educational funding through local
          agencies, private foundations, and companies for classroom supplies
          and resources.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { nittyGritty } from "@/constants/NittyGritty.js";

export default {
  name: "Template",
  data() {
    return {
      fgTitle: nittyGritty.fundsGrantedTitle
    };
  },
  methods: {
    method() {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.material-icons {
  font-size: 8rem;
}
.listed-feature {
  font-size: 1.75rem;
  margin-top: auto;
  margin-bottom: auto;
  width: calc(100% - 11rem);
}
.center-text {
  display: flex;
}
.fas {
  font-size: 8rem;
}
</style>
